import React from 'react';
import { Button } from '../atoms/button/button';
import KlarnaKIcon from '@tradera/blueprint/theme/icons-colored/klarna-k.svg?jsx';
import { classNames } from 'tradera/utils/class-names';
import css from './social-buttons.module.scss';
import FacebookIcon from '@tradera/blueprint/theme/icons2/facebook.svg?jsx';
import AppleIcon from '@tradera/blueprint/theme/icons2/network-apple.svg?jsx';

export type SocialButtonProps = React.PropsWithChildren<{
    disabled?: boolean;
    loading?: boolean;
    className?: string;
    round?: boolean;
}>;

export const KlarnaButton = ({
    round,
    className,
    children,
    ...props
}: SocialButtonProps) => {
    return (
        <Button
            fluid={!round}
            icon={<KlarnaKIcon />}
            iconConfig={
                round
                    ? {}
                    : {
                          variant: 'fixed'
                      }
            }
            theme="light"
            round={round}
            size={round ? 'md' : 'sm'}
            className={classNames(className, css.klarna, {
                [css.round]: round
            })}
            {...props}>
            {children}
        </Button>
    );
};

export const FacebookButton = ({
    round,
    className,
    children,
    ...props
}: SocialButtonProps) => {
    return (
        <Button
            fluid={!round}
            icon={<FacebookIcon />}
            iconConfig={
                round
                    ? {}
                    : {
                          variant: 'fixed'
                      }
            }
            round={round}
            size={round ? 'md' : 'sm'}
            className={classNames(className, css.facebook, {
                [css.round]: round
            })}
            {...props}>
            {children}
        </Button>
    );
};

export const AppleButton = ({
    round,
    className,
    children,
    ...props
}: SocialButtonProps) => {
    return (
        <Button
            theme="action"
            fluid={!round}
            icon={<AppleIcon />}
            iconConfig={
                round
                    ? {}
                    : {
                          variant: 'fixed'
                      }
            }
            round={round}
            size={round ? 'md' : 'sm'}
            className={classNames(className, {
                [css.round]: round
            })}
            {...props}>
            {children}
        </Button>
    );
};
